export default __webpack_public_path__ + "static/media/small.8327e012.jpg";